import { useState, useContext, memo } from "react";
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import SidebarMenu from "../../../../../components/partials/components/sidebar/sidebar-menu";
import { findIcon } from "../../../../dashboard/icons";
import { sideBarMenus } from "../utils/sideBarMenus";
import { useParams } from "react-router-dom";

function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <div
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </div>
  );
}

const EmslVerticalNav = memo(() => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [active, setActive] = useState("Summary");

  const customToogleClick = (activeKey) => {
    setActiveMenu(activeKey);
  };

  const onAccordianClick = (accordian_key) => {
    setActive(accordian_key);
  };

  return (
    <div className="sidebar-list navbar-collapse" id="sidebar">
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        {sideBarMenus.map((data, ind) => (
          <div key={`sub_menu_root_${ind}`}>
            {data?.sub_menu?.length > 0
              ? data?.sub_menu?.map((_data, sub_index) => (
                  <div key={`sub_menu_child_${sub_index}`}>
                    <SubMenuItem
                      depth={1}
                      item={_data}
                      type={"min"}
                      active={active}
                      onCustomToogleClick={customToogleClick}
                      onAccordianClick={onAccordianClick}
                    />
                  </div>
                ))
              : null}
          </div>
        ))}
      </Accordion>
    </div>
  );
});

export default EmslVerticalNav;

const SubMenuItem = ({
  type,
  active,
  depth,
  item,
  onCustomToogleClick,
  onAccordianClick,
}) => {
  const { project_id } = useParams();
  return item?.sub_menu?.length > 0 ? (
    <>
      {
        <Accordion
          as="ul"
          className="navbar-nav iq-main-menu"
          defaultActiveKey={"Summary"}
        >
          <Accordion.Item
            as="li"
            eventKey={`${item.menu_name}`}
            bsPrefix={`nav-item  ${active === item.menu_name ? "active" : ""} `}
            onClick={() => onAccordianClick(item.menu_name)}
          >
            {depth > 2 ? (
              <CustomToggle
                className="nav-link"
                eventKey={`${item.menu_name}`}
                onClick={onCustomToogleClick}
                active={active === item.menu_name ? true : false}
              >
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>{item?.menu_name}</Tooltip>}
                >
                  <i className="icon">
                    {findIcon(`${item.menu_icon}`, "dual-tone", "20")}
                  </i>
                </OverlayTrigger>
                <span className="item-name">{item?.menu_name}</span>
                <i className="right-icon">
                  <svg
                    className="submit icon-18"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
            ) : (
              <CustomToggle
                eventKey={`${item.menu_name}`}
                onClick={onCustomToogleClick}
              >
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>{item?.menu_name}</Tooltip>}
                >
                  <i className="icon">
                    {findIcon(`${item.menu_icon}`, "dual-tone", "20")}
                  </i>
                </OverlayTrigger>
                <span className="item-name">{item?.menu_name}</span>
                <i className="right-icon">
                  <svg
                    className="submit icon-18"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
            )}
            <Accordion.Collapse eventKey={`${item.menu_name}`}>
              <ul className="sub-nav">
                {item?.sub_menu?.length > 0 &&
                  item?.sub_menu.map((__data, _key) => (
                    <div key={`sub_menu_item_root_${_key}`}>
                      <SubMenuItem
                        item={__data}
                        depth={depth + 1}
                        type="sub-nav"
                        active={active}
                        onCustomToogleClick={onCustomToogleClick}
                        onAccordianClick={onAccordianClick}
                      />
                    </div>
                  ))}
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        </Accordion>
      }
    </>
  ) : (
    <>
      <SidebarMenu
        isTag="true"
        pathname={`/${item.menu_code}/${project_id}`}
        title={item.menu_name}
        sub_active_path={`${item.sub_active_path}`}
        minititle={findIcon(`${item.menu_icon}`, "dual-tone", "20")}
      >
        <div className="icon">
          {findIcon(`${item.menu_icon}`, "dual-tone", "20")}
        </div>
      </SidebarMenu>
    </>
  );
};
